/** @format */

import React from "react";
import OwlCarousel from "react-owl-carousel";

function TestimonialCarousel() {
  var settings = {
    autoplay: true,
    smartSpeed: 1000,
    center: true,
    dots: false,
    loop: true,
    nav: true,
    navText: [
      '<i class="bi bi-arrow-left"></i>',
      '<i class="bi bi-arrow-right"></i>',
    ],
    responsive: {
      0: {
        items: 1,
      },
      768: {
        items: 2,
      },
    },
  };
  return (
    <>
      <OwlCarousel
        className="owl-carousel testimonial-carousel wow fadeInUp"
        data-wow-delay="0.1s"
        loop
        margin={10}
        nav
        {...settings}
      >
        <div class="testimonial-item text-center">
          <div className="testimonial-img position-relative">
            <img
              className="img-fluid rounded-circle mx-auto mb-5"
              src="img/testimonial-1.jpg"
            />
            <div className="btn-square bg-primary rounded-circle">
              <i className="fa fa-quote-left text-white" />
            </div>
          </div>
          <div className="testimonial-text text-center rounded p-4">
            <p>
              “Navigating the company's website was an absolute delight! The
              'Home' section was engaging and informative, and the 'Contact'
              page made it easy for me to reach out with my queries. The 'Free
              Quote' option was incredibly helpful in understanding potential
              solar solutions for my new home. The registration process was a
              breeze, and being able to save products for later review was a
              game-changer. Thumbs up!”
            </p>
            <h5 className="mb-1">Client Name - Emily R</h5>
            <span className="fst-italic">Profession - New Homeowner</span>
          </div>
        </div>

        <div class="testimonial-item text-center">
          <div className="testimonial-img position-relative">
            <img
              className="img-fluid rounded-circle mx-auto mb-5"
              src="img/testimonial-2.jpg"
            />
            <div className="btn-square bg-primary rounded-circle">
              <i className="fa fa-quote-left text-white" />
            </div>
          </div>
          <div className="testimonial-text text-center rounded p-4">
            <p>
              "Their 'About Us' section was informative, and the 'Features' page
              succinctly highlighted their strengths. What stood out for me was
              the 'Our Team' section, giving a glimpse into the talented
              individuals driving their initiatives. The seamless login feature
              allowed me to bookmark favorite products and services,
              streamlining my research process. Well done!”
            </p>
            <h5 className="mb-1">Client Name - David H.</h5>
            <span className="fst-italic">
              Profession - Environmental Consultant
            </span>
          </div>
        </div>

        <div class="testimonial-item text-center">
          <div className="testimonial-img position-relative">
            <img
              className="img-fluid rounded-circle mx-auto mb-5"
              src="img/testimonial-3.jpg"
            />
            <div className="btn-square bg-primary rounded-circle">
              <i className="fa fa-quote-left text-white" />
            </div>
          </div>
          <div className="testimonial-text text-center rounded p-4">
            <p>
              "The platform beautifully showcases their commitment to renewable
              energy. The 'Our Services' section gave me insights into various
              solar solutions, and the 'Products' page was a treasure trove of
              information. The team member profiles were a nice touch, providing
              a human perspective to their expertise. The registration process
              was smooth, and having access to personalized features greatly
              enhanced my experience. Kudos to the team!”
            </p>
            <h5 className="mb-1">Client Name - Alex T. </h5>
            <span className="fst-italic">Profession - Solar Enthusiast</span>
          </div>
        </div>
      </OwlCarousel>
      ;
    </>
  );
}

export default TestimonialCarousel;
